<template>
  <div class="myNewsCenter">
    <!-- 新闻中心 -->
    <van-nav-bar :title="$t('home.name43')" left-text left-arrow @click-left="onClickLeft" :fixed="true">

    </van-nav-bar>
    <van-search v-model="searchVal" placeholder="请输入搜索关键词" @input="onSearch" />
    <div class="content">
      <van-cell 
        class="ass_cell" 
        v-for="(item, index) in assessList" 
        :key="index" 
        center 
        :label="item.crdate"
        @click="goToDetails(item)"
      >
        <template #title>
          <div class="news_title">{{ item.newstitle }}</div>
        </template>
      </van-cell>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant';
import { getAllNewsList,batchReadMsg } from '@api/wx.js'
const userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
export default {
  data() {
    return {
      userInfo,
      isLoadingAwait: false,
      loadingAwait: false,
      finishedAwait: false,
      newstitle: '',
      pageindex: 1,
      pagesize: 10,
      userid: localStorage.getItem('userid'),
      assessList: [],
      searchVal: ''
    }
  },
  created() {
    this.getAllNews()
  },
  methods: {
    onClickLeft() {
      this.$router.push('/home')
    },
    // 获取所有记录
    getAllNews() {
      let _this = this
      const userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
      getAllNewsList({
        newstitle: _this.newstitle,
        pageindex: _this.pageindex,
        pagesize: _this.pagesize,
        userid: userInfo.userid
      }).then(res => {
        /*
        只有第一页能直接赋值
        _this.assessList = res.data
        后续应该是合并数组模式
        */
        
        _this.assessList = res.data
        
        // this.totalcount = parseInt(res.totalcount)
        // this.newsList = res.data;
      })
    },
    // 跳转详情页
    goToDetails(item) {
      const from = 'center'
      if(item.fileurl) {
        if(item.fileurl.indexOf('.pdf')>-1){
          //pdf 文件
          this.$router.push({
            path: "/pdfView",
            query: {
              pdf: encodeURIComponent(item.fileurl)
            },
          });
        }else{
          window.location.href = item.fileurl
        }
      }
      else{
        this.$router.push({
          path: '/newsDetails',
          query: { autoid: item.autoid, from: from }
        })
      }
      
    },
    // 搜索
    onSearch(val) {
      if (val) {
        this.assessList = this.assessList.filter(item => {
          return item.newstitle.indexOf(val) != -1
        })
      } else {
        this.getAllNews()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.myNewsCenter {
  height: 100vh;
  overflow: hidden;

  .van-nav-bar {
    background: #2b8df0;

    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }

    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
  }

  .van-search {
    margin-top: 1.22667rem;
  }

  .content {
    overflow: auto;
    height: calc(100% - 212px);

    .ass_cell {
      /deep/.news_img {
        .van-image__img {
          border-radius: 8px;
        }
      }

      .van-cell__title {
        margin-left: 16px;

        .news_title {
          // line-height: 1.5;
          font-size: 28px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }

        .van-cell__label {
          text-align: right;
          font-size: 24px;
          font-family: Helvetica Neue;
          font-weight: bold;
          color: #999999;
        }
      }
    }
  }
}
</style>
